<template>
  <div class="form-group" :class="className">
    <label :for="inputId" class="form-label">{{ labelName }}</label>
    <input
      :id="inputId"
      :name="name"
      :aria-describedby="inputId"
      :placeholder="placeholder"
      type="number"
      :value="modelValue"
      class="form-control pj-input"
      :class="{ 'is-invalid': errorMessage }"
      @input="change($event.target.value)"
      ref="numberInput"
    />
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div :id="inputId" class="form-text"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, toRefs, watch, nextTick } from "vue";
import { useI18n } from "@/apps/admin-console/composables/useI18n";
export default defineComponent({
  name: "InputFieldNumber",
  emits: ["update:modelValue"],
  props: {
    labelName: String,
    placeholder: String,
    inputId: String,
    className: String,
    modelValue: String,
    name: {
      type: String,
      default: "",
    },
    required: { type: Boolean, default: true },
  },
  setup: (props, { emit }) => {
    const { modelValue } = toRefs(props);
    const { t } = useI18n();
    const errorMessage = ref("");
    const error = ref(false);
    const input = ref(null as HTMLInputElement | null);
    const inputValue = ref<unknown>("" as string);

    const validate = (): boolean => {
      if (!inputValue.value && props.required) {
        errorMessage.value = t("FIELD_REQUIRED");
        error.value = true;
        return false;
      } else {
        error.value = false;
        errorMessage.value = "";
      }
      emit("update:modelValue", inputValue.value);
      return true;
    };

    watch(inputValue, (value: unknown) => {
      inputValue.value = value;
      if (value !== "" && value !== undefined) {
        emit("update:modelValue", inputValue.value);
      }
    });

    watch(
      () => props.modelValue,
      () => {
        inputValue.value = props.modelValue;
      }
    );

    onMounted(() => (inputValue.value = modelValue.value));

    const change = (value: string) => {
      inputValue.value = value;
      nextTick(() => {
        validate();
        emit("update:modelValue", inputValue.value);
      });
    };

    return {
      t,
      change,
      input,
      inputValue,
      errorMessage,
      validate,
    };
  },
});
</script>
